import BaseModal, { BaseModalProps } from "../../ui/Modal";
import ReviewForm from "./ReviewForm";


interface ReviewModalProps  extends Omit<BaseModalProps , 'children'>{
 isOpen: boolean,
 onSubmit: ({comment , rating}: {comment: string , rating: number})=>void
}
export default function ReviewModal({isOpen , title , onClose , icon , onSubmit}: ReviewModalProps) {
  return (
   <BaseModal icon={icon} onClose={onClose} title={title} isOpen={isOpen}>
      <ReviewForm onSubmit={onSubmit} />
   </BaseModal>
  )
}
